import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import CatelogueInSeller from "../dashboard/singleAuction/component/CatelogueInSeller";
import { singleCompletedAuctionDetails } from "../../../redux/action/singleAuction";
import AuctionSchedule from "../dashboard/comman/AuctionSchedule";
import AuctionReportApproval from "./component/AuctionReportApproval";
import { notifyError } from "../../../helpers/helpers";

function SingleAuctionPage() {
  const navigate = useNavigate();
  const isTablet = useMediaQuery({ query: "(max-width: 800px)" });
  const isMoblie = useMediaQuery({ query: "(max-width: 500px)" });
  const { id } = useParams();
  const path = localStorage.getItem("pathurl");
  const dispatch = useDispatch();
  const { singleAuctionData, loading } = useSelector(
    (pre) => pre?.singleAuction
  );
  useEffect(() => {
    dispatch(singleCompletedAuctionDetails(id));
  }, [dispatch, id]);

  return (
    <div className="flex column gap-2">
      <span>
        <div className={`valign-wrapper space-between ${isTablet ? "flex-wrap gap-10px mb-1" : ""}`}>
          <span
            className={`valign-wrapper`}
            style={{ gap: "25px" }}
          >
            <span
              className="material-icons-outlined pointer"
              onClick={() => navigate(path === "/" ? "/" : "/auction-status")}
            >
              arrow_back
            </span>

            <h4>Auction Id: {singleAuctionData?.auctionId}</h4>
          </span>
          <span className={`valign-wrapper gap-1 ${isMoblie && "flex-wrap"}`}>
            <button
              className={`button-style pointer ${singleAuctionData?.reschedule?.status ? "grey-text" : "cercle-purple-text"} font-weight-600 font-18px font-cercular-bold`}
              disabled={singleAuctionData?.reschedule?.status}
              style={{
                padding: "5px 18px",
                border: "1px solid #6f2da8",
                opacity: singleAuctionData?.reschedule?.status ? 0.3 : 1,
              }}
              onClick={() => {
                if (singleAuctionData?.reschedule?.status) {
                  notifyError("Auction already rescheduled.");
                }
                else if (singleAuctionData?.auctionReport?.rejectedOffers?.length > 0) {
                  navigate(`/reschedule-auction/${singleAuctionData?._id}`);
                } else {
                  notifyError("No rejected offers to reschedule auction");
                }
              }}
            >
              Reschedule Auction
            </button>
            {singleAuctionData?.auctionReport && <button
              className={`button-style pointer cercle-purple white-text font-weight-600 font-18px font-cercular-bold`}
              style={{
                padding: "5px 18px",
              }}
              onClick={() => {
                navigate(`/auction-report/${id}`);
              }}
            >
              Auction Report
            </button>}
          </span>
        </div>
        <AuctionSchedule
          singleAuctionData={singleAuctionData}
          loading={loading}
        />
      </span>
      <div>
        <h5 className="margin-0px">Completed Lots List</h5>

        <AuctionReportApproval
          singleAuctionData={singleAuctionData}
          loading={loading}
        />
      </div>

      <div>
        <h5 className="margin-0px">Catalogue status</h5>
        <CatelogueInSeller auctionStatus={true} />
      </div>
    </div>
  );
}

export default SingleAuctionPage;
